module.exports = __webpack_public_path__ + "img/TheUltimateGuideToGCAnalysis.f98f7545.png";